const ThemeIntegrated = ({language , token}) => {
    const newThemeIframe = "https:" +
    window.process.env.URL_Classement + "/themes"
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_theme_display"
        src={newThemeIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ThemeIntegrated